import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { useTranslation } from "react-i18next"
import { DataResponse, ShopifyMetafieldsConfig, UpsertShopifyIntegration } from "schema"
import { toast } from "sonner"
import { z } from "zod"
import { shopifyIntegrationQuery } from "../../lib/shopify/shopifyIntegrationQuery"
import { useShopifyIntegrationQuery } from "./useShopifyIntegrationQuery"

type Response = DataResponse<z.infer<typeof UpsertShopifyIntegration>>

export function useUpdateShopifyMetafieldsConfigMutation() {
  const queryClient = useQueryClient()
  const { t } = useTranslation()
  const { data: integration } = useShopifyIntegrationQuery()

  return useMutation({
    mutationFn: async (metafieldsConfig: ShopifyMetafieldsConfig) => {
      const payload: z.infer<typeof UpsertShopifyIntegration> = {
        shopifyUrl: integration?.shopifyUrl ?? "",
        shopifyHash: integration?.shopifyHash ?? "",
        accessToken: integration?.accessToken ?? "",
        prefix: integration?.prefix,
        suffix: integration?.suffix,
        metafieldsConfig,
      }
      const response = await axios.post<Response>(`/integrations/shopify`, payload)
      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: shopifyIntegrationQuery().queryKey })
      toast.success(t("settings.integrations.shopify.metafields.saveSuccess"))
    },
    onError: () => {
      toast.error(t("settings.integrations.shopify.metafields.saveError"))
    },
  })
}
